const translations = {
    createInvoice: 'Create Invoice',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View'
};

export default translations;
